import { render, staticRenderFns } from "./teamBalance.vue?vue&type=template&id=00c1baef&scoped=true&"
import script from "./teamBalance.vue?vue&type=script&lang=js&"
export * from "./teamBalance.vue?vue&type=script&lang=js&"
import style0 from "./teamBalance.vue?vue&type=style&index=0&id=00c1baef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c1baef",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00c1baef')) {
      api.createRecord('00c1baef', component.options)
    } else {
      api.reload('00c1baef', component.options)
    }
    module.hot.accept("./teamBalance.vue?vue&type=template&id=00c1baef&scoped=true&", function () {
      api.rerender('00c1baef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DevDashboard/wallet/teamBalance.vue"
export default component.exports